module.exports = __webpack_public_path__ + "assets/img/sabc_live_icon.webp?2ca55b677b695ee75547620b97caa618";